// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"569":"019b6d38","580":"4b5702ec","818":"c6482177","936":"3a3cd7a7"}[chunkId] + ".chunk.js";
};